import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  RESET_CART_STEP,
  SET_CART_STEP,
  SET_CURRENT_LANGUAGE,
  TOGGLE_CART,
} from "../../constants/ActionTypes";
import { LANGUAGE_FR_CODE } from "../../constants/AppConstants";

const INIT_STATE = {
  error: "",
  loading: false,
  message: "",
  currentLanguage: LANGUAGE_FR_CODE,
  isCartOpen: false,
  step: 1,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return {
        ...state,
        error: "",
        message: "",
        loading: true,
        fieldsErrors: {},
      };
    }

    case FETCH_SUCCESS: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        fieldsErrors: null,
      };
    }

    case FETCH_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: "",
        fieldsErrors: action.fieldsErrors,
      };
    }
    case SET_CURRENT_LANGUAGE: {
      return {
        ...state,
        currentLanguage: action.payload,
      };
    }

    case TOGGLE_CART: {
      return {
        ...state,
        isCartOpen: action.isCartOpen,
      };
    }

    case RESET_CART_STEP: {
      return {
        ...state,
        step: 1,
      };
    }

    case SET_CART_STEP: {
      return {
        ...state,
        step: action.step,
      };
    }

    default:
      return state;
  }
};
